export default __webpack_public_path__ + "static/media/icon_fax_blue.5c5c4483.svg";